module.exports = __webpack_public_path__ + "static/media/italian_restaurant_mural_rendering_2003.e772554b.webp";